module.exports = __webpack_public_path__ + "static/media/card-empty-large.8b7b187b.png";